import React from 'react';
// Un utilitaire JavaScript simple pour joindre de manière conditionnelle des noms de classe
import classNames from 'classnames';
import { Link } from 'react-router-dom';

export default function RocketItem({
    rocket: { id, name, country, company, active, first_flight }
}) {
    return (
        <div className="card card-body mb-3">
            <div className="row">
                <div className="col-md-9">
                    <h4>
                        Name: {''}
                        <span
                            className={classNames({
                                'text-success': active,
                                'text-danger': !active
                            })}
                        >
                            {name}
                        </span>
                    </h4>
                    <p>First flight: {''} {first_flight} </p>
                    <p>Conpany: {''} {company} </p>
                </div>
                <div className="col-md-3 mt-4">
                    {/* <div>{id}</div> */}
                    <Link to={`/rocket/${id}`} className="mt-4 shadow-sm btn btn-secondary">Rocket Details</Link>
                </div>
            </div>
        </div>
    );
};
